<template>
  <p class="detail-row text_small" :class="{ 'detail-row--left': alignLeft }" >
    <span class="detail-row__key" :style="{width: colWidth[0]+'%', color: keyTextColor}">{{ prop }}</span>
    <slot class="detail-row__value" :style="{color: valueTextColor}"/>
    <span class="detail-row__value" :class="{'capitalize': capitalize, 'bold': bold}"
          :style="{width: colWidth[1]+'%', color: valueTextColor}"
          v-if="!$slots.default">
      <span class="detail-row__value-text" :id="copiable ? `clipboard-target-${id}` : ''" v-html="value || '—'">
      </span>
      <md-button
        v-if="copiable"
        class="detail-row__clipboard-btn md-icon-button"
        id="clipboard-btn"
        @click="showCopySuccess"
        :data-clipboard-target="`#clipboard-target-${id}`"
      >
        <md-icon class="detail-row__clipboard-icon md-icon-size-065x">content_copy</md-icon>
        <md-tooltip>Copy</md-tooltip>
      </md-button>
    </span>
  </p>
</template>

<script>
  import Clipboard from 'clipboard'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { i18n } from '@js/i18n'

  export default {
    name: 'detail-row',
    props: {
      prop: { type: String, default: '' },
      value: { type: [String, Number], default: '' },
      alignLeft: { type: Boolean, default: false },
      colWidth: { type: Array, default: () => ['auto', 'auto'] },
      copiable: { type: Boolean, default: false },
      valueTextColor: {type: String, default: '$col-text'},
      keyTextColor: {type: String, default: '$col-md-accent'},
      capitalize: {type: Boolean, default: false},
      bold: {type: Boolean, default: false}
    },
    data: _ => ({
      clipboard: null,
      id: null
    }),
    mounted () {
      this.id = this._uid
      if (!this.copiable) return
      this.clipboard = new Clipboard(this.$el.querySelector('#clipboard-btn'))
    },
    methods: {
      showCopySuccess () {
        EventDispatcher.dispatchShowSuccessEvent(i18n.dep_copied())
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .capitalize {
    text-transform: capitalize;
  }
  .bold {
    font-weight: 600;
  }
  .detail-row {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &--left {
      justify-content: flex-start;
    }
  }

  .detail-row__key {
    flex: 1 1 auto;
    margin-right: 10px;
  }

  .detail-row__value {
    position: relative;
    flex: 1 1 auto;
    /*max-width: 25%;*/
    text-align: right;

    .detail-row__clipboard-btn {
      position: absolute;
      top: -4px;
      right: -48px;
    }
  }

  .detail-row__value-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/common/Detail.Row.vue